import { Injectable } from '@angular/core';
import { HOME } from '../interfaces/home.interface';
import { Observable, catchError, map, of, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { homeJson } from '../pages/home/home.json';

@Injectable({
  providedIn: 'root'
})
export class HomeService {

  endpointApi = environment.apiCMSHome
  endpointApiRetalk = environment.apiCmsRetalk
  endpointApiCasos = environment.apiCmsCasos
  endpointApiTeam = environment.apiCmsTeam

  homeContent: any;
  homePodcast: any;
  homeCaso: any;
  homeTeamMember: any;

  constructor(private http: HttpClient) { }

  // Handle API errors =================================
  handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An client error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.log("Backend error code " + error.status + ", body was: " + JSON.stringify(error.error));
    }
    // return an observable with a user-facing error message
    return throwError(() => error.error)
  }

  getHome() {
    this.homeContent = this.http.get<any>(this.endpointApi + '/get?id=1')
      .pipe(
        map(resp => {
          return resp.data.home;
        }),
        catchError(this.handleError)
      )
    return this.homeContent
  }


  getTeamMember(id: number) {
    this.homeTeamMember = this.http.get<any>(this.endpointApiTeam + '/find?id=' + id)
      .pipe(
        map(resp => {
          return resp.data.teammate;
        }),
        catchError(this.handleError)
      )
    return this.homeTeamMember
  }


  getCaso(id: number) {
    this.homeCaso = this.http.get<any>(this.endpointApiCasos + '/find?id=' + id)
      .pipe(
        map(resp => {
          return resp.data.case;
        }),
        catchError(this.handleError)
      )
    return this.homeCaso
  }

}
